import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getVentilatorSelector } from '../selectors'
import { setAddToTimeLine } from '../store/ventilator.actions'
import { VentilatorConstants } from '../store/ventilator.constants'
import { IVentilatorState } from '../store/ventilator.types'
import { addVentilatorItem } from '../../../timeline/store/timeline.actions'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { handleNemsisCodeError, getUpdatedProcedureStateWithNemsisCode } from '../../../../utilities/nemsisCode.util'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* saveVentilator() {
  let ventilatorState: IVentilatorState = yield select(getVentilatorSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  if (!pcrID) {
    // todo: add to audit log
    return
  }

  try {
    ventilatorState = getUpdatedProcedureStateWithNemsisCode({
      procedureState: ventilatorState,
      actionField: null,
      filter1Field: null,
      filter2Field: null,
      filter3Field: null,
      nemsisCodeOptions,
    })
  } catch (error: unknown) {
    ventilatorState = handleNemsisCodeError(error, ventilatorState)
  }

  const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
  if (pcrDoc.patient?.ventilatorStateList && pcrDoc.patient?.ventilatorStateList.length) {
    const index = pcrDoc.patient?.ventilatorStateList?.findIndex((ventilator) => ventilator.key === ventilatorState.key)
    if (index !== -1) {
      pcrDoc.patient.ventilatorStateList[index] = ventilatorState
    } else {
      pcrDoc.patient?.ventilatorStateList.push(ventilatorState)
    }
  } else {
    pcrDoc.patient = { ...pcrDoc.patient, ventilatorStateList: [ventilatorState] }
  }
  try {
    const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient } }
    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    yield put(setAddToTimeLine(true))
    yield put(addVentilatorItem())
  } catch (e) {
    yield put(throwPcrException(`saveVentilator() error: ${e}`))
  }
}

export function* saveVentilatorSaga() {
  yield takeLatest(
    [
      VentilatorConstants.SAVE_VENTILATOR,
      VentilatorConstants.SET_DATE,
      VentilatorConstants.SET_TIME,
      VentilatorConstants.SET_ACTION,
      VentilatorConstants.SET_DATE_TIME,
      VentilatorConstants.SET_ASSESSED_BY,
      VentilatorConstants.SET_RESPONSE,
      VentilatorConstants.SET_RESPONSE_PNNV,
      VentilatorConstants.SET_PROCEDURE_COMPLICATIONS,
      VentilatorConstants.SET_AUTHORIZATION,
      VentilatorConstants.SET_ROLE_PERFORMING,
      VentilatorConstants.SET_ROLE_PERFORMING_PNNV,
      VentilatorConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
      VentilatorConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
      VentilatorConstants.SET_ATTEMPTS,
      VentilatorConstants.SET_VENTILATOR_CHECK,
      VentilatorConstants.SET_ACTION,
      VentilatorConstants.SET_PTA,
    ],
    performWithMutexHOG,
    saveVentilator
  )
}
